module.exports = __webpack_public_path__ + "img/a.ffe02075.png";